import { Articulo } from '../../articulo/articulo';
import { Precio } from '../../precio/precio';
import { Factura } from '../factura';

export class DetalleFactura {
    n?:number;
    id?:string;
    item?:string;
    idproduct?:string;
    cantidad?:string;
    valorunit?:string;
    descuento?:string;
    igv?:string;
    descrip?:string;
    impneto?:string;
    cmoneda?:string;
    preuni?:string;
    unidad?:string;
    unico?:string;
    idfactura?:string;
    id_det?:string;
    totdscto?:string;
    igvi?:string;
    afectoigv?:string;
    montoisc?:string;
    valgratui?:string;
    impnetoct?:string;
    preunict?:string;
    dcto_valor?:string;
    iddet?: string;
    idprecio?:string;
    factura?:Factura;
    articulo?:Articulo;
    precio?:Precio;
    impto_cbp?:string;
    icbp?:number;
    idzona?:string;
    ingreso?:number;
    saldo?:number;
    isprestamo?:boolean = false;
    
    esCantidadInvalida?:boolean;
    constructor(){
        this.factura = new Factura();
        this.articulo = new Articulo();
        this.precio = new Precio();
    }
}
